import React, {useContext, useEffect, useState, useCallback} from 'react';
import {UserContext} from '@context/UserContext';
import Button from '@common/Button';
import {ChevronRightIcon, ChevronLeftIcon} from '@common/icons/';
import {BrandContext} from "@context/BrandContext";
import {ContentContext} from "@context/ContentContext";
import Tooltip from "@common/Tooltip";
import useCurrentConcept from "@hooks/useCurrentConcept";
import {debounce} from 'lodash';

const PreviousNextLesson = props => {
    const {className, compressed} = props;
    const brandConfig = useContext(BrandContext);
    const {user, setUser} = useContext(UserContext);
    const {content, contentLoading} = useContext(ContentContext);
    const {loadCurrentConcept, loadPreviousConcept, loadNextConcept} = useCurrentConcept();

    const handleLoadPreviousConcept = () => {
        loadPreviousConcept(localStorage.getItem("conceptId"));
    };

    const debouncedHandleLoadPreviousConcept = useCallback(debounce(handleLoadPreviousConcept, 1000, { 'leading': true }), [user.cmsMode]);

    const handleLoadNextConcept = () => {
        loadNextConcept(localStorage.getItem("conceptId"));
    };

    const debouncedHandleLoadNextConcept = useCallback(debounce(handleLoadNextConcept, 1000, { 'leading': true }), [user.cmsMode]);

    if(content === undefined || content.currentConcept === undefined) {
        return null;
    }

    return (
        <div className="ch-menu-block">
            <div className={'ch-menu-previous-next'}>
                <Tooltip title={'Previous ' + brandConfig.conceptName} placement="top" enterNextDelay={100} disable={!compressed} disableInteractive>
                    <span>
                        <Button
                            onClick={debouncedHandleLoadPreviousConcept}
                            className={'ch-menu-previous-next-text'}
                            disabled={content.currentConcept.previousConceptId == undefined}
                            type={'text'}
                        >
                            <ChevronLeftIcon /><span>Previous</span>
                        </Button>
                    </span>
                </Tooltip>
                <Tooltip title={'Next ' + brandConfig.conceptName} placement="top" enterNextDelay={100} disable={!compressed} disableInteractive>
                    <span>
                        <Button
                            onClick={debouncedHandleLoadNextConcept}
                            className={'ch-menu-previous-next-text'}
                            disabled={content.currentConcept.nextConceptId == undefined}
                            type={'text'}
                        >
                            <span>Next</span><ChevronRightIcon />
                        </Button>
                    </span>
                </Tooltip>
            </div>
        </div>
    );
}

export default PreviousNextLesson;